<template>
  <div class="bankTransfer" :class="[lang, { showFinishedText: showFinishedText }]">
    <PullRefresh v-model="loadOnPullDown" @refresh="reset">
        <List
            v-model="loading"
            :finished="finished"
            :finished-text="$t('bankTransfer.b000011')"
            offset="50"
            @load="loadMore">
            <template v-if="accountAuthArray.length">
                <div class="top">
                    <template v-for="(item, index) in accountAuthArray">
                        <div class="item" :key="index" v-if="item.isVisible == 1" @click="toPage(item)">
                            <img class="icon" :src="item.img" />
                            <div class="content">{{ item.name }}</div>
                            <span class="bankCard" v-if="item.key == 'bankCard' && bankCount > 0">{{ bankTransferMessage }}</span>
                            <img class="arrow light" src="@/assets/images/app-pages/arrow-right.png" />
                            <img class="arrow dark" src="@/assets/images/app-pages/darkRight.png" />
                        </div>
                    </template>
                </div>
            </template>
            <div class="bot" v-if="isLoading == 2">
                <div class="title">{{ $t('bankTransfer.b000012') }}</div>
                <div class="nav">
                    <div class="navItem" :class="{ active: item.value == activeTab }" v-for="(item, index) in navList" :key="index" @click="toggleParams(item.value)">
                        <span class="text">{{ item.title }}</span>
                    </div>
                </div>
                <!-- 资金列表 -->
                <div class="container">
                    <template v-if="moneyRecords.length > 0">
                        <div class="item" v-for="(item, index) in moneyRecords" :key="index" @click="toOrder(item)">
                            <div class="left">
                                <div class="box">
                                    <div class="status" :class="getFundsChangeTypeInfo(item.funds_change_type).color">{{ getFundsChangeTypeInfo(item.funds_change_type).text }}</div>
                                    <div class="money">{{ item.is_all == 1 ? $t('withdrawNew.lang6') : getAmount(item.amount) }} {{ item.remittance_currency }}</div>
                                </div>
                                <div class="date">{{ formatDate(item.created_at) }}</div>
                            </div>
                            <div class="right" :class="getOrderStatus(item.order_status).color">{{ getOrderStatus(item.order_status).text }}</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="empty">
                            <img class="emptyIcon" src="../../../assets/images/app-pages/nodata02 .png" >
                            <span class="text">{{ $t('bankTransfer.b000019') }}</span>
                        </div>
                    </template>
                </div>
            </div>
        </List>
    </PullRefresh>
  </div>
</template>

<script>
import bankTransfer1 from '@/assets/images/app-pages/bankTransfer1.png'
import bankTransfer2 from '@/assets/images/app-pages/bankTransfer2.png'
import bankTransfer3 from '@/assets/images/app-pages/bankTransfer3.png'
import bankTransfer4 from '@/assets/images/app-pages/bankTransfer4.png'
import bankTransfer5 from '@/assets/images/app-pages/bankTransfer5.png'
import { getBrowser } from "@/utils/browser";
import { List, PullRefresh } from 'vant';
import { localeString } from '@/utils/utils.new';
import { formatDate } from '../tools/tools';
export default {
    name: 'bankTransfer',
    components: {
        List,
        PullRefresh
    },
    data() {
        this.authFieldNames = {
            "withdrawIn": {
                name: this.$t('bankTransfer.b000007'),
                img: bankTransfer5,
                path: '/bank-card-list',
                queryParams: {
                    showType: 2,
                    account_no: 'account_no',
                    account_type: 'account_type'
                }
            },
            "withdrawOut": {
                name: this.$t('bankTransfer.b000008'),
                img: bankTransfer1,
                path: '/app-pages/withdraw',
                queryParams: {
                    account_no: 'account_no',
                    account_type: 'account_type'
                }
            },
            "exchange": {
                name: this.$t('bankTransfer.b000013'),
                img: bankTransfer2,
                path: '/app-pages/moneyExchange',
                queryParams: {
                    account_no: 'account_no',
                    account_type: 'account_type'
                }
            },
            "fundsTransfer": {
                name: this.$t('bankTransfer.b000014'),
                img: bankTransfer3,
                path: '/app-pages/fundsTransfer',
                queryParams: {
                    account_no: 'account_no',
                    account_type: 'account_type'
                }
            },
            "bankCard": {
                name: this.$t('bankTransfer.b000015'),
                img: bankTransfer4,
                path: '/bank-card-list',
                queryParams: {
                    showType: 1
                }
            }
        };
        this.navList = [
            { title: this.$t('bankTransfer.b000010'), value: 0 },
            { title: this.$t('bankTransfer.b000007'), value: 1 },
            { title: this.$t('bankTransfer.b000008'), value: 2 },
            { title: this.$t('bankTransfer.b000009'), value: 5 },
        ];
        return {
            loading: true,         // 列表是否在加载中
            finished: false,        // 列表是否到底
            accountAuthArray: [],      // 可使用权限列表
            moneyRecords: [],           // 资金记录列表
            activeTab: 0,
            bankCount: 0,           // 银行卡数量
            isLoading: 1,
            lang: 'zh-CN',
            loadOnPullDown: false
        }
    },
    computed: {
        getOrderStatus() {
            return order_status => {
                // 定义一个映射对象，其中每个订单状态对应一个对象，包含文本和颜色类。
                const statusMap = {
                    0: { text: this.$t('bankTransfer.b000001'), color: "wait-color" },
                    1: { text: this.$t('bankTransfer.b000002'), color: "success-color" },
                    2: { text: this.$t('bankTransfer.b000003'), color: "fail-color" },
                    3: { text: this.$t('bankTransfer.b000004'), color: "auto-color" },
                    4: { text: this.$t('bankTransfer.b000005'), color: "back-color" },
                    5: { text: this.$t('bankTransfer.b000006'), color: 'cancel-color' }
                };

                // 获取对应的状态信息，如果不存在则返回默认值。
                const statusInfo = statusMap[order_status] || { text: '未知状态', color: "" };

                // 返回一个对象，包含状态文本和颜色类。
                return {
                    text: statusInfo.text,
                    color: statusInfo.color
                };
            }
        },
        getFundsChangeTypeInfo() {
            return funds_change_type => {
                const typeMap = {
                    1: { text: this.$t('bankTransfer.b000007'), color: "green-color" },
                    2: { text: this.$t('bankTransfer.b000008'), color: "red-color" },
                    5: { text: this.$t('bankTransfer.b000009'), color: "money-color" }
                };
                const typeInfo = typeMap[funds_change_type] || { text: "", color: "" };
                return {
                    text: typeInfo.text,
                    color: typeInfo.color
                };
            }
        },
        formatDate() {
            return dateStr => {
                return formatDate(dateStr);
            }
        },
        bankTransferMessage() {
            // 英文情况，带空格
            if (this.lang == 'en') {
                return `${this.$t('bankTransfer.b000017')} ${this.bankCount} ${this.$t('bankTransfer.b000018')}`;
            } else {
                // 非英文情况，没有空格
                return `${this.$t('bankTransfer.b000017')}${this.bankCount}${this.$t('bankTransfer.b000018')}`;
            }
        },
        showFinishedText() {
            return this.moneyRecords.length == 0;
        }
    },
    created() {
        this.init();
        this.lang = localStorage.getItem("localLang") || 'zh-CN';
        // 提供函数供app调用
        this.$JsBridge.registerHandler("showWebView", () => {
            this.reset();
        });
    },
    methods: {
        init() {
            this.getRouteParams();
            this.getBankCard();
            this.getPermissions();
            this.getFundsRecords();
        },
        getBankCard() {
            this.$apis.getBankCard({ showLoading: true }).then( res => {
                this.bankCount = (res && res.length) ? res.length : 0;
            })
        },
        getPermissions() {
            this.$apis.getAuthList({ showLoading: true }).then( res => {
                if ( res?.accountAuth ) {
                    // 将对象转换为所需的数组格式
                    this.accountAuthArray = Object.keys(this.authFieldNames).map(key => {
                        const item = this.authFieldNames[key];
                        const queryString = Object.entries(item.queryParams)
                            .map(([paramKey, paramValue]) => {
                                // 如果paramValue是字符串，则从this.query中取值，否则使用固定值
                                const value = typeof paramValue === 'string' ? this.query[paramValue] : paramValue;
                                return `${paramKey}=${value}`;
                            })
                            .join('&');

                        return {
                            name: item.name,
                            isVisible: res.accountAuth[key] || 1,
                            img: item.img,
                            path: queryString ? `${item.path}?${queryString}` : item.path,
                            key
                        };
                    });
                }
            })
        },
        getFundsRecords() {
            this.$apis.getFundsList(this.query).then( res => {
                // 写入数据
                if ( this.query.page == 1 ) {
                    this.moneyRecords = res.data;
                } else {
                    this.moneyRecords = [...this.moneyRecords, ...res.data];
                }
                this.loading = false;
                this.loadOnPullDown = false;
                this.isLoading = 2;
                // 是否到底
                if ( res.total == this.moneyRecords.length ) {
                    this.finished = true;
                }
            })
        },
        getRouteParams() {
            this.query = {
                page: 1,
                page_size: 10,
                account_no: this.$route.query.account_no,
                account_type: this.$route.query.account_type,
                funds_change_type: this.activeTab
            };
        },
        toggleParams(value) {
            this.activeTab = value;
            this.query.funds_change_type = value;
            this.query.page = 1;
            this.loading = true;
            this.finished = false;
            this.getFundsRecords();
        },
        reset() {
            this.query.page = 1;
            this.loading = true;
            this.finished = false;
            this.init();
        },
        toPage(item) {
            const browser = getBrowser();
            const isAPP = browser.isApp;
            if( isAPP ) {
                this.$JsBridge.callHandler('jumpPage', {
                    type: 1,
                    url: `${window.location.origin}${item.path}`,
                })
            } else {
                this.$router.push({ path: item.path });
            }
        },
        getAmount(num) {
            return localeString(num)
        },
        toOrder( item ) {
            const browser = getBrowser();
            const isAPP = browser.isApp;
            if( isAPP ) {
                this.$JsBridge.callHandler('jumpPage', {
                    type: 1,
                    url: `${window.location.origin}/funds-order-detail?id=${item.record_id}&orderType=${item.funds_change_type}&account_type=${item.funds_account_type}`,
                })
            } else {
                this.$router.push({
                    path: "/funds-order-detail",
                    query: {
                        id: item.record_id,
                        orderType: item.funds_change_type,
                        account_type: item.funds_account_type
                    }
                });
            }
        },
        loadMore() {
            this.query.page += 1;
            this.getFundsRecords();
        },
        onRefresh() {
            this.loadOnPullDown = true;
            this.reset();
        }
    }
}
</script>

<style lang="less" scoped>
.bankTransfer {
    min-height: 100vh;
    /deep/ .van-pull-refresh {
        min-height: 100vh;
    }
    .top {
        .item {
            display: flex;
            padding: 20px 0px;
            align-items: center;
            margin: 0 32px;
            position: relative;
            .icon {
                width: 96px;
                height: 96px;
            }
            .content {
                flex: 1;
                font-weight: 500;
                color: #17161C;
                font-size: 32px;
                line-height: 32px;
                margin-left: 24px;
            }
            .bankCard {
                font-size: 28px;
                line-height: 28px;
            }
            .arrow {
                width: 32px;
                height: 32px;
                display: none;
            }
            &::after {
                content: '';
                display: block;
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 1px;
                background-color: #F3F3F3;
                transform: scaleY(0.5);
                transform-origin: bottom;
            }
        }
    }
    .bot {
        margin-top: 30px;
        .title {
            font-size: 34px;
            font-weight: 600;
            color: #17161C;
            padding: 24px 32px;
        }
        .nav {
            display: flex;
            align-items: center;
            padding: 10px 0px;
            margin: 0 32px;
            .navItem {
                background: rgba(23,22,28,0.04);
                border-radius: 30px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0px 28px;
                line-height: 48px;
                font-size: 24px;
                min-width: 76px;
                max-width: 108px;
                color: #17161C;
                margin-right: 16px;
                white-space: nowrap;
                border: 1px solid transparent;
                box-sizing: border-box;
                .text {
                    transform: translateY(2px);
                }
                &.active {
                    background: rgba(0,72,153,0.20);
                    border-color: rgba(0,72,153,0.30);
                    color: #004899;
                }
            }
        }
        .container {
            margin: 0 32px;
            .item {
                display: flex;
                align-items: center;
                padding: 32px 0px;
                position: relative;
                .left {
                    flex: 1;
                    margin-right: 15px;
                    .box {
                        display: flex;
                        align-items: center;
                    }
                    .status {
                        font-size: 32px;
                        line-height: 32px;
                        font-weight: 500;
                        &.red-color {
                            color: #EE3A53;
                        }
                        &.green-color {
                            color: #00A76F;
                        }
                        &.money-color {
                            color: #F24E1E;
                        }
                    }
                    .money {
                        font-size: 32px;
                        line-height: 32px;
                        font-weight: 500;
                        color: #17161C;
                        margin-left: 24px;
                    }
                    .date {
                        color: #B9B9B9;
                        font-size: 28px;
                        line-height: 28px;
                        margin-top: 16px;
                    }
                }
                .right {
                    text-align: right;
                    font-weight: 500;
                    font-size: 32px;
                    &.wait-color {
                        color: #F24E1E;
                    }
                    &.success-color {
                        color: #00A76F;
                    }
                    &.fail-color {
                        color: #EE3A53;
                    }
                    &.back-color {
                        color: #17161C;
                    }
                    &.cancel-color {
                        color: #747377;
                    }
                    &.auto-color {
                        color: #377CFB;
                    }
                }
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 1px; /* 实际边框的高度 */
                    background-color: #F3F3F3;
                    transform: scaleY(0.5); /* 缩小边框的视觉厚度 */
                    transform-origin: bottom;
                }
            }
            .empty {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin: 60px 0px;
                .emptyIcon {
                    width: 130px;
                    height: 140px;
                }
                .text {
                    font-size: 28px;
                    color: #747377;
                }
            }
        }
    }
    &.showFinishedText {
        /deep/ .van-list__finished-text {
            display: none;
        }
    }
    &.en {
        .bot {
            .item {
                .left {
                    .money {
                        font-size: 28px;
                    }
                }
            }
        }
    }
}
.white-theme {
    .item {
        .light {
            display: block !important;
        }
    }
}
.black-theme {
    .content {
        color: white !important;
    }
    .top {
        .item {
            &::after {
                background-color: #323442;
            }
            .dark {
                display: block !important;
            }
            .bankCard {
                color: white;
            }
        }
    }
    .bot {
        .title {
            color: white !important;
        }
        .nav {
            border-color: #323442;
            .navItem {
                background: #24252D;
                color: #8B8C9C !important;
                &.active {
                    background: rgba(55,124,251,0.20);
                    border-color: rgba(55,124,251,0.30);
                    color: #377CFB !important;
                }
            }
        }
        .container {
            .item {
                .box {
                    .money {
                        color: white !important;
                    }
                }
                &::after {
                    background-color: #323442;
                }
                .back-color {
                    color: #9D9D9F !important;
                }
                .cancel-color {
                    color: #9D9D9F !important;
                }
            }
        }
    }
}

</style>
